// generated by genversion
export var version = '4.3.6';
//# sourceMappingURL=version.js.map